// 在 utils/cnzz.js 中定义 CNZZ 统计方法
export default function trackEvent (category, action, label, value) {
    var config = JSON.parse(localStorage.getItem('config'))
    if (window._czc && config.ymtj_id) {
      window._czc.push(['_trackEvent', category, action, label, value])
    }
  }